import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseCustomDialog } from '../base-custom-dialog';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CONTACTS_DATA_SERVICE, ContactsDataService } from '../../../../services/contacts/contacts-data.service';
import { ContactMethod } from '../../../../models/contacts/contacts.model';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import {
  Articles,
  ConstructionTypes,
  CreateLead, Keyword, LeadsDataContactObject,
  LeadSources,
  LeadType,
} from '../../../../models/leads/leads.model';
import { LOCALE_KEY, UserTokenService } from '../../../../services/user-service/user-token.service';
import { IFileDocument } from '../../../../models/shared.model';
import { ILeadContact } from '../../../../models/leads/leads.model';
import { ContactFormComponent } from '../../components/contact-form/contact-form.component';
import { PhoneNumberHelper } from '../../../../helper/phone-number.helper';
import { AddressHelper } from '../../../../helper/address.helper';
import { Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { HideLoader, ShowLoader } from '../../../store/loader/loader.actions';
import { AppointmentCreatePopupComponent } from "../appointment-create-popup/appointment-create-popup.component";
import { ConvertHelper } from "../../../../helper/convert.helper";
import { ACTION_DATA_SERVICE, ActionDataService } from "../../../../services/action/data.service";
import { TextHelper } from '../../../../helper/text.helper';
import { ValidatorHelper } from '../../../../helper/validator.helper';
import { LeadHelper } from '../../../../helper/lead.helper';
import { ContactHelper } from '../../../../helper/contact.helper';
import {
  APPOINTMENT_CREATION_ERROR,
  LAST_SAVED_COUNTRY_CODE,
  LAST_SELECTED_ADDITIONAL_MOBILE_PHONE_PREFIX, LAST_SELECTED_COUNTRY_CODE, LAST_SELECTED_LANGUAGE_CODE,
  LAST_SELECTED_MOBILE_PHONE_PREFIX,
  LAST_SELECTED_PHONE_PREFIX
} from '../../../../constants/constants';
import { UserProfileShareService } from '../../../../services/shared-service/user-profile-share.service';

@Component({
  templateUrl: './new-request.component.html',
  styleUrls: ['./new-request.component.scss'],
  standalone: false,
})
export class NewRequestComponent extends BaseCustomDialog implements OnDestroy, OnInit {

  @ViewChild(ContactFormComponent) contactFormElComponent: ContactFormComponent;

  @ViewChild(AppointmentCreatePopupComponent) appointment: AppointmentCreatePopupComponent;

  @ViewChildren('inputs') inputs: QueryList<ElementRef>;

  submitting: boolean;
  contactMethods: ContactMethod[];
  showErrors = false;
  leadTypes: LeadType[];
  constructionTypes: ConstructionTypes[];
  brochures: { value: string, text: string, image: string }[];
  ausschreibungstextes: { value: string, text: string, image: string }[];
  cadDatens: { value: string, text: string, image: string }[];
  musters: { value: string, text: string }[];
  leadSources: LeadSources[];
  tags: string[] = [];
  shownPossibleTags: string[] = [];
  privacy = {
    contact: true,
    documented: true
  };
  userName = '';
  privacyDocument: IFileDocument;
  isLongDescription = false;
  defaultConstructionTypeId = 3;
  leadTypeRelationshipManagement = LeadHelper.LEAD_TYPE_PLANER_RELATIONSHIP;
  leadTypeOffer = LeadHelper.LEAD_TYPE_OFFER;
  leadSourceId = LeadHelper.LEAD_SOURCE_TELEFON;
  leadTypeBrochure = LeadHelper.LEAD_TYPE_BROCHURE;
  leadTypeMuster = LeadHelper.LEAD_TYPE_MUSTER;
  leadTypeAusschreibungstexte = LeadHelper.LEAD_TYPE_AUSSCHREIBUNGSTEXTE;
  leadTypeCadDaten = LeadHelper.LEAD_TYPE_CAD_DATEN;
  showAppointments = false;
  selectedLeadTypeId: number;
  comission = '';
  existingContact: LeadsDataContactObject;
  gotExistingContactDetails = false;
  contactComponentProxy = new Proxy({}, {
    apply( target, thisArg, argArray ) {
    },
    get( target, p, receiver ) {
    },
    set( target, p, value, receiver ) {
      return true
    }
  });

  selectedMusterKeys: string[] = [];
  selectedBrochureKeys: string[] = [];
  selectedAusschreibungstexteKeys: string[] = [];
  selectedCadDatenKeys: string[] = [];
  sameAsContactAddress: boolean = true;
  allRequiredFieldsFilled = false;
  isShared = false;
  isDealerPartner: boolean;
  IsPremiumProjectPartner: boolean;
  showSharedLeadCheckbox = false;
  showLeadTypeAngebot = false;
  showLeadTypeBrochure = false;
  showLeadTypeMuster = false;
  showLeadTypeAusschreibungstexte = false;
  showLeadTypeCadDaten = false;
  hideLeadTypeAngebotMobile = false;
  hideLeadTypeBrochureMobile = false;
  hideLeadTypeAusschreibungstexte = false;
  hideLeadTypeCadDaten = false;
  hideLeadTypeMusterMobile = false;
  hideDetails = false;
  broschureLabelText: string = '';
  musterLabelText: string = '';
  ausschreibungstexteLabelText: string = '';
  cadDateLabelText: string = '';
  leadCreationFailureRelationshipManagementError = false;

  contactForm = this.fb.group({
    Id: this.fb.control(null),
    ContactTypeId: this.fb.control(ContactHelper.CONTACT_TYPE_PRIVATE),
    ContactMethodId: this.fb.control(1),
    Salutation: this.fb.control('', Validators.required),
    FirstName: this.fb.control('', [Validators.required, Validators.pattern(ValidatorHelper.nameValidator)]),
    LastName: this.fb.control('', [Validators.required, Validators.pattern(ValidatorHelper.nameValidator)]),
    JobTitle: this.fb.control('', [Validators.pattern(ValidatorHelper.positionValidator)]),
    Email: this.fb.control('', [Validators.email, Validators.pattern(ValidatorHelper.emailValidator)]),
    AdditionalEmail: this.fb.control('', [Validators.email, Validators.pattern(ValidatorHelper.emailValidator)]),
    Phone: this.fb.control('', [Validators.pattern(PhoneNumberHelper.phoneValidator)]),
    PhonePrefix: this.fb.control('', [Validators.pattern(PhoneNumberHelper.countryCodeValidator)]),
    Mobile: this.fb.control('', [Validators.pattern(PhoneNumberHelper.phoneValidator)]),
    PhoneOther: this.fb.control('', [Validators.pattern(PhoneNumberHelper.phoneValidator)]),
    MobilePrefix: this.fb.control('', [Validators.pattern(PhoneNumberHelper.countryCodeValidator)]),
    PhoneOtherPrefix: this.fb.control('', [Validators.pattern(PhoneNumberHelper.countryCodeValidator)]),
    LanguageCode: this.fb.control('', Validators.required),
    Company: this.fb.control('', Validators.pattern(ValidatorHelper.companyValidator)),
    Address: this.fb.control('', Validators.pattern(ValidatorHelper.addressValidator)),
    TaxNumber: this.fb.control('', Validators.pattern(ValidatorHelper.taxNumberValidator)),
    AddressExt: this.fb.control('', Validators.pattern(ValidatorHelper.addressValidator)),
    ZipCode: this.fb.control('', Validators.pattern(ValidatorHelper.zipValidator)),
    City: this.fb.control('', Validators.pattern(ValidatorHelper.cityValidator)),
    ProvinceCode: this.fb.control(''),
    CountryCode: this.fb.control(''),
    VatNumber: this.fb.control('', Validators.pattern(ValidatorHelper.vatNumberValidator)),
    Website: this.fb.control('', Validators.pattern(ValidatorHelper.urlValidator)),
    Title: this.fb.control(''),
    CustomerCode: this.fb.control(''),
    CustomerCodeComposer: this.fb.control(''),
  });

  requestForm = this.fb.group({
    LeadTypeId: this.fb.control(this.leadTypeOffer, Validators.required),
    LeadSourceId: this.fb.control(null, Validators.required),
    LeadText: this.fb.control(''),
    ConstructionTypeId: this.fb.control(this.defaultConstructionTypeId)
  });

  addressForm = this.fb.group({
    Commission: this.fb.control(''),
    Address: this.fb.control('', Validators.pattern(ValidatorHelper.addressValidator)),
    ZipCode: this.fb.control('', Validators.pattern(ValidatorHelper.zipValidator)),
    City: this.fb.control('', Validators.pattern(ValidatorHelper.cityValidator)),
    CountryCode: this.fb.control(''),
    ProvinceCode: this.fb.control('')
  });

  extPropertiesForm = this.fb.group({
    PLANER_CODE: this.fb.control('', [Validators.pattern(ValidatorHelper.planerNumberValidator)]),
  });

  private loadedLeadTypes = [];
  private allPossibleTags: string[] = [];
  private attachments: IFileDocument[];
  private formSubscription: Subscription;
  private consentThirdParties: boolean;
  private consentMarketing: boolean;


  constructor(
    public dialogRef: MatDialogRef<NewRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contact: LeadsDataContactObject },
    private fb: UntypedFormBuilder,
    private userTokenService: UserTokenService,
    @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    private readonly sharedProfileService: UserProfileShareService,
    private store: Store
  ) {
    super(dialogRef);
    this.existingContact = dialogData?.contact;

    this.initUpdateSubmitEnable();

    if ( this.existingContact?.Id ) {
      contactsDataService.getContacts(this.existingContact.Id).subscribe(( { success, data } ) => {
        if ( success ) {
          this.contactForm.patchValue(data);
          this.contactForm.controls.Salutation.setValue(data.SalutationId);
          this.gotExistingContactDetails = true;

          this.consentMarketing = data.ConsentMarketing;
          this.consentThirdParties = data.ConsentThirdParties;
        }
      });
    }

    this.sharedProfileService.getIsDealerPartner().subscribe(isDealerPartner => {
      this.isDealerPartner = isDealerPartner;
    });

    this.sharedProfileService.getIsPremiumProjectPartner().subscribe(IsPremiumProjectPartner => {
      this.IsPremiumProjectPartner = IsPremiumProjectPartner;
      this.updateViewState();
    });

    leadsDataService.getAllKeywords().subscribe(( { success, data } ) => {
      if ( success ) {
        this.shownPossibleTags = this.allPossibleTags = data;
      }
    });

    contactsDataService.getContactMethods().subscribe(( { success, data } ) => {
      if ( success ) {
        this.contactMethods = data;
      }
    });

    leadsDataService.getLeadTypes().subscribe(( { success, data } ) => {
      if ( success ) {
        this.loadedLeadTypes = data.filter(item => !item.Inactive);
        this.updateLeadTypesDropdown();
        this.setDynamicLabelKeys();
      }
    });

    const locale = sessionStorage.getItem(LOCALE_KEY);

    leadsDataService.getBrochures(locale).subscribe(( { success, data } ) => {
      if ( success ) {
        this.brochures = data.map(item => ({
          text: item.title + '\n' + item.ordernumber,
          value: item.key,
          image: item.img
        }));
      }
    });

    leadsDataService.getAusschreibungstextes(locale).subscribe(( { success, data } ) => {
      if ( success ) {
        this.ausschreibungstextes = data.map(item => ({
          text: item.title + (item.ordernumber ? '\n' + item.ordernumber : ''),
          value: item.key,
          image: 'none'
        }));
      }
    });

    leadsDataService.getCadDatens(locale).subscribe(( { success, data } ) => {
      if ( success ) {
        this.cadDatens = data.map(item => ({
          text: item.title + (item.ordernumber ? '\n' + item.ordernumber : ''),
          value: item.key,
          image: 'none'
        }));
      }
    });

    leadsDataService.getMusters(locale).subscribe(( { success, data } ) => {
      if ( success ) {
        this.musters = data.map(item => ({ text: item.title, value: item.key, image: item.img }));
      }
    });

    leadsDataService.getConstructionTypes().subscribe(( { success, data } ) => {
      if ( success ) {
        this.constructionTypes = data.filter(item => !item.Inactive);
      }
    });

    leadsDataService.getLeadSources().subscribe(( { success, data } ) => {
      if ( success ) {
        if (this.isDealerPartner) {
          this.leadSources = data.filter(item => !item.Inactive && !item.FinstralOnly);
        } else {
          this.leadSources = data.filter(item => !item.Inactive);
        }
      }
    });

    this.userName = userTokenService.getName();

    this.valueChanges();

    this.prefillFormFields();
  }

  ngOnInit(): void {
    this.selectedLeadTypeId = this.requestForm.controls.LeadTypeId.value;
    this.updateViewState();
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }

  updateLeadTypesDropdown(): void {
    this.leadTypes = this.loadedLeadTypes;
  }

  initUpdateSubmitEnable(): void {
    const forms = [this.requestForm, this.addressForm, this.extPropertiesForm];

    if ( !this.existingContact ) {
      forms.push(this.contactForm);
    }

    const onUpdate = () => {
      this.allRequiredFieldsFilled = true;
      this.updateLeadTypesDropdown();

      for ( const form of forms ) {
        for ( const control in form.controls ) {
          if ( form.controls[control].hasValidator(Validators.required) && !form.controls[control].value ) {
            this.allRequiredFieldsFilled = false;
            return;
          }
        }
      }

      if ( this.getContactFormComponent().checkIfEmailOrPhoneNeedsToBeFilled?.(true, true) ) {
        this.allRequiredFieldsFilled = false;
        return;
      }
    };

    forms.forEach(form => form.valueChanges.subscribe(onUpdate));
  }

  valueChanges(): void {
    this.formSubscription = new Subscription();

    this.formSubscription.add(this.requestForm.controls.LeadTypeId.valueChanges.subscribe(val => {

      for ( const fieldName of ['ZipCode', 'City', 'Address', 'CountryCode'] ) {
        if ( val === LeadHelper.LEAD_TYPE_BROCHURE || val === LeadHelper.LEAD_TYPE_MUSTER || val === LeadHelper.LEAD_TYPE_AUSSCHREIBUNGSTEXTE ) {
          this.setValidators(fieldName);
        } else {
          this.clearValidators(fieldName);
        }

        this.contactForm.controls[fieldName].updateValueAndValidity();
      }

      this.updateViewState();
    }));

    this.formSubscription.add(this.contactForm.controls.ContactTypeId.valueChanges.subscribe(() => {
      this.updateViewState();
    }));
  }

  clearValidators( fieldName: string ): void {
    switch ( fieldName ) {
      case 'ZipCode':
        this.contactForm.controls[fieldName].setValidators([Validators.pattern(ValidatorHelper.zipValidator)]);
        break;
      case 'City':
        this.contactForm.controls[fieldName].setValidators([Validators.pattern(ValidatorHelper.cityValidator)]);
        break;
      case 'Address':
        this.contactForm.controls[fieldName].setValidators([Validators.pattern(ValidatorHelper.addressValidator)]);
        break;
      default:
        this.contactForm.controls[fieldName].clearValidators();
        break;
    }
  }

  setValidators( fieldName: string ): void {
    switch ( fieldName ) {
      case 'ZipCode':
        this.contactForm.controls[fieldName].setValidators([Validators.required, Validators.pattern(ValidatorHelper.zipValidator)]);
        break;
      case 'City':
        this.contactForm.controls[fieldName].setValidators([Validators.required, Validators.pattern(ValidatorHelper.cityValidator)]);
        break;
      case 'Address':
        this.contactForm.controls[fieldName].setValidators([Validators.required, Validators.pattern(ValidatorHelper.addressValidator)]);
        break;
      default:
        this.contactForm.controls[fieldName].setValidators(Validators.required);
        break;
    }
  }

  updateTags(): void {
    this.tags = [...new Set(this.tags.filter(tag => tag.trim()))];
    this.shownPossibleTags = this.allPossibleTags.filter(tag => !this.tags.includes(tag));
  }

  closeDialog( message?: string ): void {
    this.clearClassAndCloseDialog(this.dialogRef, message);
  }

  submitData(): void {
    this.getContactFormComponent().leadCreationFailureError = false;
    this.getContactFormComponent().leadCreationFailureRelationshipManagementError = this.leadCreationFailureRelationshipManagementError = false;
    this.showErrors = false;
    let contactFormValid = true;

    if ( typeof this.getContactFormComponent().scrollToInvalidContactField === 'function' ) {
      this.getContactFormComponent().scrollToInvalidContactField();
    }

    this.scrollToInvalidRequestField();

    if ( this.isValidContact() || this.requestForm.invalid ) {
      this.getContactFormComponent().showMaxLengthErrors = false;
      this.getContactFormComponent().showErrors = true;
      this.showErrors = true;
      contactFormValid = false;
    } else {
      this.getContactFormComponent().showMaxLengthErrors = false;
      this.getContactFormComponent().showErrors = false;
      this.showErrors = false;
      contactFormValid = true;
    }

    if ( this.extPropertiesForm.invalid ) {
      this.getContactFormComponent().showMaxLengthErrors = true;
      this.showErrors = true;
      contactFormValid = false;
    }

    if ( !contactFormValid || this.isLongDescription ) {
      return;
    }

    if ( !this.privacy.contact || !this.privacy.documented ) {
      this.getContactFormComponent().showErrors = this.showErrors = true;
      return;
    }

    if ( this.selectedLeadTypeId !== this.leadTypeRelationshipManagement && this.addressForm.invalid ) {
      this.addressForm.markAsTouched();
      return;
    }

    this.createLead();
  }

  scrollToInvalidRequestField(): void {
    const formRequest = Object.keys(this.requestForm.controls);

    formRequest.forEach(item => {
      if ( this.requestForm.controls[item].invalid ) {
        this.inputs.forEach(( input: ElementRef ) => {
          this.checkContainClass(input, item);
        });
      }
    });
  }

  checkContainClass( input, item ): void {
    const headerHeight = 150;

    if ( input.nativeElement?.classList.contains(item) ) {
      const scrollPosition = (input.nativeElement as HTMLElement).offsetTop;
      document.querySelector('.mat-mdc-dialog-container').scrollTo({
        top: scrollPosition - headerHeight,
        behavior: 'smooth'
      });
    }
  }

  setLeadTypeId( typeId: number ): void {
    this.showErrors = false;
    this.leadCreationFailureRelationshipManagementError = false;
    if ( typeId !== this.leadTypeOffer ) {
      this.extPropertiesForm.reset();
      this.requestForm.controls.ConstructionTypeId.reset();
    } else {
      this.setConstructionTypeId(this.defaultConstructionTypeId);
    }

    this.selectedLeadTypeId = typeId;
    this.requestForm.controls.LeadTypeId.setValue(typeId);
  }

  setConstructionTypeId( eventTypeId: number ): void {
    this.requestForm.controls.ConstructionTypeId.setValue(eventTypeId);
  }

  capitalizeFirstLetter( field ): string {
    if ( !field ) {
      return '';
    }
    return field.charAt(0).toUpperCase() + field.substr(1);
  }

  getBody(): CreateLead {
    const contactData = this.contactForm.getRawValue();
    sessionStorage.setItem(LAST_SAVED_COUNTRY_CODE, contactData.CountryCode);

    contactData.FirstName = this.capitalizeFirstLetter(contactData.FirstName);
    contactData.LastName = this.capitalizeFirstLetter(contactData.LastName);
    contactData.Address = this.capitalizeFirstLetter(contactData.Address);
    contactData.City = this.capitalizeFirstLetter(contactData.City);
    contactData.ProvinceCode = this.capitalizeFirstLetter(contactData.ProvinceCode);
    contactData.SalutationId = contactData.Salutation ?? null;

    if ( !contactData.Email && contactData.ContactMethodId === 1 ) {
      contactData.ContactMethodId = undefined;
    }

    if ( !contactData.Phone && contactData.ContactMethodId === 2 ) {
      contactData.ContactMethodId = undefined;
    }

    if ( !contactData.Mobile && contactData.ContactMethodId === 3 ) {
      contactData.ContactMethodId = undefined;
    }

    if ( contactData.ContactTypeId === ContactHelper.CONTACT_TYPE_PRIVATE ) {
      contactData.Title = undefined;
      contactData.Company = undefined;
      contactData.JobTitle = undefined;
      contactData.VatNumber = undefined;
      contactData.Website = undefined;
    }

    if ( !contactData.ContactMethodId ) {
      if ( contactData.Email ) {
        contactData.ContactMethodId = 1;
      } else if ( contactData.Phone ) {
        contactData.ContactMethodId = 2;
      } else if ( contactData.Mobile ) {
        contactData.ContactMethodId = 3;
      } else {
        contactData.ContactMethodId = 1;
      }
    }

    return {
      Contact: {
        ...contactData,
        IsShared: this.isShared,
        PhonePrefix: this.contactForm.controls.Phone.value?.trim() ? this.contactForm.controls.PhonePrefix.value : null,
        MobilePrefix: this.contactForm.controls.Mobile.value?.trim() ? this.contactForm.controls.MobilePrefix.value : null,
        ConsentMarketing: this.consentMarketing,
        ConsentThirdParties: this.consentThirdParties,
      } as ILeadContact | any,
      ...this.requestForm.getRawValue(),
      LeadText: TextHelper.sanitizeHtml(this.requestForm.controls.LeadText.value),
      ExtendedProperties: this.extPropertiesForm.getRawValue(),
      PrivacyDocument: this.privacyDocument || undefined,
      PrivacyText: document.getElementById('privacyTextAgreementText')?.innerText,
      PrivacyDate: new Date().toISOString(),
      Commission: this.selectedLeadTypeId !== this.leadTypeRelationshipManagement ? this.addressForm.getRawValue()?.Commission : undefined,
      LeadAddress: !this.sameAsContactAddress && this.selectedLeadTypeId !== this.leadTypeRelationshipManagement ? {
        Address: this.addressForm.getRawValue()?.Address,
        ZipCode: this.addressForm.getRawValue()?.ZipCode,
        City: this.addressForm.getRawValue()?.City,
        CountryCode: this.addressForm.getRawValue()?.CountryCode,
        ProvinceCode: this.addressForm.getRawValue()?.ProvinceCode
      } : undefined,
      Attachments: this.attachments?.length ? this.attachments : undefined,
      Articles: this.getArticles(),
    } as CreateLead;
  }

  createLead(): void {
    const body = this.getBody();
    this.submitting = true;
    this.store.dispatch(new ShowLoader());

    this.leadsDataService.createLead(body).subscribe(( { success, data, error } ) => {
      if ( success ) {
        Promise.all([
          this.updateSharedStatusIfNeeded(data),
          this.sendTags(data),
        ]).then(() => {
          if ( !this.showAppointments ) {
            this.store.dispatch(new HideLoader());
            this.closeDialog(`${data}`);
          } else {
            this.createAppointment(data);
          }
        });
      } else {
        this.store.dispatch(new HideLoader());
        this.getContactFormComponent().showErrors = true;
        this.showErrors = true;
        if (this.selectedLeadTypeId === this.leadTypeRelationshipManagement) {
          this.getContactFormComponent().leadCreationFailureRelationshipManagementError = this.leadCreationFailureRelationshipManagementError = true;
        } else {
          this.getContactFormComponent().leadCreationFailureError = true;
        }

        setTimeout(() => {
          const scrollPosition = document.getElementById('lead-creation-error-message')?.offsetTop ?? 0;
          document.querySelector('.mat-mdc-dialog-container')?.scrollTo({ top: scrollPosition - 120, behavior: 'smooth' });
        }, 20)
      }
      this.submitting = false;
    });
  }

  sendTags( leadId: number ): Promise<void> {
    return new Promise((resolve => {
      if ( !this.tags.length ) {
        resolve();
        return;
      }

      this.leadsDataService.sendKeyWords(this.tags, leadId).subscribe(() => {
        resolve();
      })
    }));
  }

  isInvalidForm( form: string, fieldName: string ): boolean {
    return this.showErrors && this[form].controls[fieldName].invalid;
  }

  getLeadAddress(): string {
    const addressObj = this.addressForm.getRawValue();
    return AddressHelper.getLeadAddress(addressObj);
  }

  contactAddressToDisplay(): string {
    const contactAddress = this.contactForm.getRawValue();
    return AddressHelper.getLeadAddress(contactAddress);
  }

  onPrivacyDocumentUpload( doc: IFileDocument ): void {
    this.privacyDocument = doc;
  }

  onAttachmentsUpdate( attachments: IFileDocument[] ): void {
    this.attachments = attachments;
    this.attachments.length === 0 ? this.requestForm.controls.LeadText.setValidators([Validators.required]) : this.requestForm.controls.LeadText.clearValidators();
    this.requestForm.controls.LeadText.updateValueAndValidity();
  }

  onMarketingChanges( $event: { consentThirdParties: boolean; consentMarketing: boolean } ): void {
    this.consentThirdParties = $event.consentThirdParties;
    this.consentMarketing = $event.consentMarketing;
  }

  onChangeSharedStatus(): void {
  }

  isValidAppointment(): boolean {
    return !!this.appointment?.selectedDate && !!this.appointment?.appointmentTypeId && !this.appointment?.inValidNote;
  }

  isValidContact(): boolean {
    if ( this.existingContact ) {
      return !this.gotExistingContactDetails;
    }

    const contactControls = this.contactForm.controls;
    const formContact = Object.keys(contactControls);
    let isValid = false;

    formContact.forEach(item => {
      if ( !!contactControls[item].errors?.required || !!contactControls[item].errors?.pattern ) {
        isValid = true;
      }
    });

    if ( this.getContactFormComponent().isInvalidProvinceCode(true) ) {
      isValid = true;
    }

    if ( this.getContactFormComponent().checkIfEmailOrPhoneNeedsToBeFilled() ) {
      isValid = true;
    }

    return isValid;
  }

  private getArticles(): Articles[] | null {
    const articles: Articles[] = [];

    if ( this.leadTypeBrochure === this.selectedLeadTypeId ) {
      this.selectedBrochureKeys.map(key => this.brochures.find(brochure => brochure.value === key)).forEach(item => {
        articles.push({
          Description: item.text,
          Article: item.value
        });
      });
    }

    if ( this.leadTypeAusschreibungstexte === this.selectedLeadTypeId ) {
      this.selectedAusschreibungstexteKeys.map(key => this.ausschreibungstextes.find(ausschreibungstexte => ausschreibungstexte.value === key)).forEach(item => {
        articles.push({
          Description: item.text,
          Article: item.value
        });
      });
    }

    if ( this.leadTypeCadDaten === this.selectedLeadTypeId ) {
      this.selectedCadDatenKeys.map(key => this.cadDatens.find(cadDaten => cadDaten.value === key)).forEach(item => {
        articles.push({
          Description: item.text,
          Article: item.value
        });
      });
    }

    if ( this.leadTypeMuster === this.selectedLeadTypeId ) {
      this.selectedMusterKeys.map(key => this.musters.find(muster => muster.value === key)).forEach(item => {
        articles.push({
          Description: item.text,
          Article: item.value
        });
      });
    }

    return articles.length ? articles : null;
  }

  private createAppointment( leadId: number ): void {

    if ( this.isValidAppointment() ) {
      if ( !!this.appointment.extendedProperties.OFFER_AMOUNT ) {
        this.appointment.extendedProperties.OFFER_AMOUNT = ConvertHelper.currencyToNumber(this.appointment.extendedProperties.OFFER_AMOUNT);
      }
      this.actionDataService.createAppointment(
        leadId,
        this.appointment.note,
        this.appointment.appointmentTypeId,
        this.appointment.selectedDate,
        this.appointment.extendedProperties,
        this.appointment.showroomTypeId,
      ).subscribe(( { success, data } ) => {

        sessionStorage.setItem(APPOINTMENT_CREATION_ERROR, ( !success).toString());
        this.store.dispatch(new HideLoader());
        this.closeDialog(`${leadId}`);
      });
    }
  }

  private prefillFormFields(): void {
    this.requestForm.controls.LeadSourceId.setValue(this.leadSourceId);
    const mobilePhonePrefix = sessionStorage.getItem(LAST_SELECTED_MOBILE_PHONE_PREFIX) ?? '';
    const phonePrefix = sessionStorage.getItem(LAST_SELECTED_PHONE_PREFIX) ?? '';
    const additionalMobilePhonePrefix = sessionStorage.getItem(LAST_SELECTED_ADDITIONAL_MOBILE_PHONE_PREFIX) ?? '';
    const languageCode = sessionStorage.getItem(LAST_SELECTED_LANGUAGE_CODE) ?? '';
    const countryCode = sessionStorage.getItem(LAST_SELECTED_COUNTRY_CODE) ?? '';
    this.contactForm.controls.MobilePrefix.setValue(mobilePhonePrefix);
    this.contactForm.controls.PhonePrefix.setValue(phonePrefix);
    this.contactForm.controls.PhoneOtherPrefix?.setValue(additionalMobilePhonePrefix);
    this.contactForm.controls.LanguageCode.setValue(languageCode);
    this.contactForm.controls.CountryCode.setValue(countryCode);
  }

  private setDynamicLabelKeys(): void {
    for (const lead of this.loadedLeadTypes) {
      if (lead.Id === this.leadTypeBrochure) {
        this.broschureLabelText = lead.Description;
      }
      if (lead.Id === this.leadTypeMuster) {
        this.musterLabelText = lead.Description;
      }
      if (lead.Id === this.leadTypeAusschreibungstexte) {
        this.ausschreibungstexteLabelText = lead.Description;
      }
      if (lead.Id === this.leadTypeCadDaten) {
        this.cadDateLabelText = lead.Description;
      }
    }
  }

  private updateSharedStatusIfNeeded( leadId: number ): Promise<void> {
    return new Promise(resolve => {
      if ( !this.isShared ) {
        resolve();
        return;
      }

      this.actionDataService.updateIsSharedStatus(leadId, this.isShared).subscribe(() => {
        resolve();
      });
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateViewState();
  }

  private updateViewState(): void {
    const isMobile = window.innerWidth <= 768;
    const contactTypeId = this.contactForm.controls.ContactTypeId.value;

    this.showSharedLeadCheckbox = this.IsPremiumProjectPartner && (
      contactTypeId === ContactHelper.CONTACT_TYPE_PLANER ||
      contactTypeId === ContactHelper.CONTACT_TYPE_TRADE
    );

    if ( this.showSharedLeadCheckbox ) {
      this.isShared = true;
    }

    if ( !this.showSharedLeadCheckbox && this.isShared ) {
      this.isShared = false;
    }

    this.showLeadTypeAngebot = this.selectedLeadTypeId === this.leadTypeOffer;
    this.showLeadTypeBrochure = this.selectedLeadTypeId === this.leadTypeBrochure;
    this.showLeadTypeMuster = this.selectedLeadTypeId === this.leadTypeMuster;
    this.showLeadTypeAusschreibungstexte = this.selectedLeadTypeId === this.leadTypeAusschreibungstexte;
    this.showLeadTypeCadDaten = this.selectedLeadTypeId === this.leadTypeCadDaten;

    this.hideLeadTypeAngebotMobile = isMobile || this.selectedLeadTypeId !== this.leadTypeOffer;
    this.hideLeadTypeBrochureMobile = isMobile || this.selectedLeadTypeId !== this.leadTypeBrochure;
    this.hideLeadTypeAusschreibungstexte = isMobile || this.selectedLeadTypeId !== this.leadTypeAusschreibungstexte;
    this.hideLeadTypeCadDaten = isMobile || this.selectedLeadTypeId !== this.leadTypeCadDaten;
    this.hideLeadTypeMusterMobile = isMobile || this.selectedLeadTypeId !== this.leadTypeMuster;
    this.hideDetails = ![
      this.leadTypeOffer,
      this.leadTypeMuster,
      this.leadTypeBrochure,
      this.leadTypeAusschreibungstexte,
      this.leadTypeCadDaten,
    ].includes(this.selectedLeadTypeId);
  }

  private getContactFormComponent(): ContactFormComponent {
    return this.contactFormElComponent ?? (this.contactComponentProxy as any);
  }
}
